export default __webpack_public_path__ + "static/media/Press_Release_q3.b91540cf.pdf";